var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2112.25 2011.641",
    enableBackground: "new 0 0 2112.25 2011.641",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M1148.159,502.913h872.057c50.829,0,92.034,41.205,92.034,92.034v821.766 c0,50.829-41.205,92.034-92.034,92.034h-872.057c-50.829,0-92.034-41.205-92.034-92.034V594.947 C1056.125,544.118,1097.33,502.913,1148.159,502.913z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M1609.333,502.913c0.102,24.41-9.697,47.818-27.158,64.876L1207,942.965l-35.707,35.707 c-4.626,4.456-9.495,8.654-14.585,12.573c-15.053,9.507-32.488,14.563-50.292,14.585c-24.41,0.102-47.818-9.697-64.876-27.158 L630.657,567.789c-31.013-30.579-36.069-78.823-12.07-115.168c3.594-5.202,7.632-10.082,12.07-14.585L1041.54,27.154 c35.304-35.83,92.97-36.256,128.801-0.952c0.32,0.315,0.637,0.632,0.952,0.952l410.883,410.883 C1599.636,455.095,1609.435,478.503,1609.333,502.913z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M1609.333,1508.746c-0.012,277.753-225.186,502.907-502.939,502.895 c-179.658-0.008-345.667-95.853-435.504-251.436c-9.677-16.085-18.084-32.9-25.146-50.292c-7.41-16.35-13.793-33.147-19.111-50.292 c-83.326-264.96,63.917-547.301,328.877-630.627c48.83-15.356,99.718-23.168,150.906-23.165c17.099,0,33.695,1.006,50.292,2.515 c16.906,1.454,33.703,3.974,50.292,7.544C1441.009,1063.993,1609.051,1269.844,1609.333,1508.746z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M1207,544.655v1073.224c-0.25,37.292-22.849,70.794-57.333,84.993 c-10.98,4.645-22.78,7.039-34.701,7.041H645.745c-7.41-16.35-13.793-33.147-19.111-50.292 c-83.326-264.96,63.917-547.301,328.877-630.627c48.83-15.356,99.718-23.168,150.905-23.165 c-24.41,0.102-47.818-9.697-64.876-27.158L630.657,567.789c-31.013-30.579-36.069-78.823-12.07-115.168h496.379 c34.426,0.206,65.859,19.609,81.473,50.292C1203.507,515.681,1207.146,530.062,1207,544.655z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    enableBackground: "new    ",
    d: "M1156.708,594.947v1073.224c-0.002,11.922-2.396,23.722-7.041,34.701 c-14.199,34.484-47.701,57.083-84.993,57.333H670.891c-9.677-16.085-18.084-32.9-25.146-50.292 c-7.41-16.35-13.793-33.147-19.111-50.292c-83.326-264.96,63.917-547.301,328.877-630.627 c48.83-15.356,99.718-23.168,150.906-23.165c-24.41,0.102-47.818-9.697-64.876-27.158L630.657,567.789 c-17.46-17.058-27.259-40.466-27.157-64.876h461.175c25.505-0.089,49.837,10.704,66.888,29.672 C1147.64,549.373,1156.644,571.702,1156.708,594.947z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    enableBackground: "new    ",
    d: "M1156.708,594.947v972.641c-0.383,50.669-41.365,91.651-92.034,92.034h-438.04 c-83.326-264.96,63.917-547.301,328.877-630.627c48.83-15.356,99.718-23.168,150.906-23.165 c-24.41,0.102-47.818-9.697-64.876-27.158L630.657,567.789c-17.46-17.058-27.259-40.466-27.157-64.876h461.175 c25.505-0.089,49.837,10.704,66.888,29.672C1147.64,549.373,1156.644,571.702,1156.708,594.947z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    enableBackground: "new    ",
    d: "M1106.417,594.947v410.883c-24.41,0.102-47.818-9.697-64.876-27.158 L630.657,567.789c-17.46-17.058-27.259-40.466-27.157-64.876h410.883C1065.132,503.106,1106.224,544.198,1106.417,594.947z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    enableBackground: "new    ",
    d: "M1106.417,1005.83v561.758c-0.383,50.669-41.364,91.651-92.034,92.034H626.634 c-83.326-264.96,63.917-547.301,328.877-630.627C1004.341,1013.638,1055.229,1005.827,1106.417,1005.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.2069,
    y1: 1683.361,
    x2: 914.2097,
    y2: 432.882,
    gradientTransform: "matrix(1 0 0 -1 0 2114.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2368C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#1A5DBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1146AC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M92.185,502.913h922.047c50.912,0,92.185,41.272,92.185,92.185v922.047 c0,50.912-41.272,92.185-92.185,92.185H92.185C41.272,1609.33,0,1568.057,0,1517.145V595.098 C0,544.186,41.272,502.913,92.185,502.913z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M523.033,1153.084c16.932,49.889,26.99,81.372,30.175,94.448h2.062 c3.051-13.076,13.931-46.788,32.639-101.136l134.128-389.962h123.315l-227.57,599.326H485.717l-224.2-599.326h126.836 L523.033,1153.084z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisio);
export default __webpack_public_path__ + "static/media/Visio.56c7a871f3a43f9df8a08e68bd692c37.svg";
export { ForwardRef as ReactComponent };